<script>
  import ArticleTag from 'src/pc/pages/ArticleTag'
  import PageLayout from '../layouts/PageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import SubPageLayout from '../layouts/SubPageLayout'
  import PostContainer from '../components/PostContainer'
  export default {
    extends: ArticleTag,
    components: {
      SubPageLayout,
      PageLayout,
      DisplayContainer,
      PostContainer,
    },
    computed: {
      getAccess() {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .article_tag .tag {
    display: block;
    text-align: center;
    border-bottom: 1px solid #000;
    padding-bottom: 35px;
  }
  .article_tag .tag p {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 5px;
  }
  .article_tag .tag p.ctry_kr {
    font-family: 'Roboto Slab' ,'SUIT Variable';
    font-size: 27px;
    font-weight: 800;
  }
</style>
